import { Config } from "./configTypes";
import malaysiaConfig from "./malaysiaConfig";
import triveInternationalConfig from "./triveInternationalConfig";
import triveInvestConfig from "./triveInvestConfig";

const getConfig = (): Config => {
  const url = window.location.href;

  if (url.includes("malaysia")) {
    return malaysiaConfig;
  } else if (url.includes("international")) {
    return triveInternationalConfig;
  } else if (url.includes("triveinvest")) {
    return triveInvestConfig;
  }

  return triveInternationalConfig;
};

export default getConfig;
